import { captureException } from '@sentry/react';
import { createContext, PropsWithChildren, useContext } from 'react';

import { ShopModel, shopClient } from '@portal-clients/shop';

import { useClientQuery } from '@frontend/hooks';

import { usePortalConfiguration } from './configuration-context';

export interface ShopContextType {
  shop: ShopModel | undefined;
}

export const ShopContext = createContext<ShopContextType>(null!);

export const ShopProvider = (props: PropsWithChildren) => {
  const {
    config: { features, topupConfig },
  } = usePortalConfiguration();

  const { data: shop } = useClientQuery({
    queryKey: ['shop', topupConfig?.shopId ?? ''],
    onFetch: async () => {
      if (!topupConfig!.shopId) {
        return Promise.reject(
          new Error(
            'Missing shop ID in topupConfig even though topup is enabled',
          ),
        );
      }

      return await shopClient.get(topupConfig!.shopId!);
    },
    enabled: features?.topup?.enabled,
    onError(error) {
      captureException(error);
    },
  });

  return (
    <ShopContext.Provider
      value={{
        shop: shop,
      }}
    >
      {props.children}
    </ShopContext.Provider>
  );
};

export const useShopContext = () => {
  return useContext(ShopContext);
};
